<template>
  <validation-observer ref="articuleEdit">
    <div class="row">
      <div class="col-8 justify-content-left align-items-center">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="articleName"
            :error="errors[0]"
            maxlength="250"
            placeholder="Escriba aquí para editar artículo..."
            custom-error-msg="El nombre de artículo es requerido."
          />
        </validation-provider>
      </div>
      <div class="col-4 text-right">
        <action-button
          i="fas fa-save text-green pr-1"
          class="btn btn-border-green mr-3"
          @click="onSaveHandler"
        />
        <action-button
          i="fas fa-times-circle text-red pr-1"
          class="btn btn-border-red mr-3"
          @click="$emit('onClose')"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'ArticleEdit',
  mixins: [alertMixin],
  components: {
    CustomInput,
    ActionButton,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      articleName: null,
    };
  },
  async mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.articleName = this.value;
    },
    async onSaveHandler() {
      const isValid = await this.$refs.articuleEdit.validate();
      if (!isValid) {
        this.ShowToast('Atención', 'Favor escriba un artículo.', 'error');
        return;
      }
      this.$emit('onSaveArticle', this.articleName);
    },
  },
};
</script>

<style scoped>
.btn-border-green {
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
}

.btn-border-red {
  border: 1px solid #c9545e;
  border-radius: 4px;
  opacity: 1;
}
</style>
